import React from "react";
import { inject, observer } from "mobx-react";
import { FormGroup, InputGroup, FormControl, Button } from "react-bootstrap";
import { StoreContext } from "../../contexts/StoreContext";

@inject("detailViewStore", "popupStore", "previewStore")
@observer
export default class ListSearch extends React.Component {
  static contextType = StoreContext;
  render() {
    const { placeholder } = this.props;
    const { searchMatrixKey } = this.props;
    return (
      <FormGroup className="bucket-search-bar">
        <InputGroup>
          <FormControl
            type="text"
            value={this.context.getSearchMatrix[searchMatrixKey] || ""}
            onChange={(e) => {
              this.context.setSearchMatrix(searchMatrixKey, e.target.value);
            }}
            placeholder={placeholder}
          />
          <InputGroup.Button>
            <Button
              onClick={() => {
                this.context.setSearchMatrix(searchMatrixKey, "");
              }}
            >
              Clear
            </Button>
          </InputGroup.Button>
        </InputGroup>
      </FormGroup>
    );
  }
}
